
import React, {useState} from 'react'
type Props = {
  status: string,
  className?:string,
  preText?:string
}

const statusClass:any={
    "In Progress":"warning",
    "Pending":"warning", //orange
    "Completed":"success",
    "Approved":"success",
    "Submitted":"info",
    "Submitted For Approval":"info",
    "Rerouted" : "info"
}
const Status: React.FC<Props> = ({ status,className,preText}) => {

  return (
    <span className={`badge badge-light-${statusClass[status]} ${className}`}>{preText}{status}</span>
  )
}
export default Status